import { create } from "zustand";
import * as api from "../services/nominatim";

export const useNominatimStore = create((set) => ({
  available: null,

  fetchHealth: async () => {
    const result = await api.getNominatimHealth();
    if (result.data) {
      set({ available: result.data.available });
    }
    return result;
  },
}));
